import { useContext } from 'react';
import {
    ConfirmedSelection,
    ConfirmedSelectionContext,
} from './ConfirmedSelectionProvider';

/**
 * Picks a dose or a structure set through the question
 * {@link ConfirmedSelectionProvider} asks before a pick that changes what
 * the user did not pick.
 */
export default function useConfirmedSelection(): ConfirmedSelection {
    const selection = useContext(ConfirmedSelectionContext);
    if (!selection) {
        throw new Error(
            'useConfirmedSelection needs a ConfirmedSelectionProvider.'
        );
    }
    return selection;
}
